// 引入路由
import router from "@/router/index"

let timeOut = 5 * 60 * 1000  //设置超时时间: 5分钟
 
window.onload = function () {
  window.document.onmousedown = function () {
    setItem("lastTime", new Date().getTime())
  }
  window.onscroll = function(){
    setItem("lastTime", new Date().getTime())
  }
};
 
//设置最后操作时间
function setItem(key, value) {
    value = JSON.stringify(value);
    window.localStorage.setItem(key, value)
}

//获取最后操作时间
function getItem(key, defaultValue) {
    let value = window.localStorage.getItem(key);
    return JSON.parse(value) || defaultValue;
}

//检查是否超时
function checkTimeout() {
  let currentTime = new Date().getTime()
  let lastTime = window.localStorage.getItem("lastTime");
  //判断是否超时
  if (currentTime - lastTime > timeOut) {
    router.push({ name: 'home' })
    // if(router.history.current.path == '/home'){
    //   location.reload();
    // }
  }
}

//间隔30秒检查是否超时
export default function () {
  window.setInterval(checkTimeout, 30000);
}


// WEBPACK FOOTER //
// ./src/libs/delayExit.js